<template>
  <article class="card">
    <header class="head">
      <h2 class="title">Security mode</h2>
      <p class="desc">
        Activa funciones sensibles (ej. borrado total de evento) y ajusta señales visuales en la app.
      </p>
    </header>

    <div class="row">
      <label class="check">
        <input type="checkbox" v-model="enabled" :disabled="loading || saving" />
        <span>Activar security mode</span>
      </label>

      <span class="pill" :class="enabled ? 'on' : 'off'">
        {{ enabled ? 'ACTIVO' : 'INACTIVO' }}
      </span>
    </div>

    <div class="warnbox" v-if="enabled">
      <strong>Precaución:</strong> con Security Mode activo se habilitarán acciones destructivas.
    </div>

    <div class="actions">
      <button class="btn primary" :disabled="loading || saving" @click="save">
        {{ saving ? 'Guardando…' : 'Guardar' }}
      </button>

      <button class="btn" :disabled="loading || saving" @click="reload">
        Recargar estado
      </button>

      <span class="hint" v-if="hint">{{ hint }}</span>
    </div>
  </article>
</template>

<script>
import { SecurityModeService } from '../Services/SecurityModeService';

export default {
  name: 'SecurityModeCard',
  data() {
    return {
      enabled: false,
      loading: false,
      saving: false,
      hint: ''
    };
  },
  methods: {
    async reload() {
      this.loading = true;
      this.hint = '';
      try {
        const r = await SecurityModeService.getStatus({ force: true });
        this.enabled = !!r.enabled;
        this.hint = 'Estado actualizado desde servidor';
        this.$store?.commit?.('setSecurityMode', this.enabled);
      } catch (e) {
        window?.$toast?.error?.(e?.message || 'No se pudo cargar');
      } finally {
        this.loading = false;
      }
    },

    async save() {
      if (this.enabled) {
        const ok = confirm('Vas a ACTIVAR Security Mode. ¿Confirmas?');
        if (!ok) return;
      }

      this.saving = true;
      this.hint = '';
      try {
        await SecurityModeService.setEnabled(this.enabled);
        this.$store?.commit?.('setSecurityMode', this.enabled);
        window?.$toast?.success?.(`Security Mode: ${this.enabled ? 'ACTIVO' : 'INACTIVO'}`);
        this.hint = 'Guardado correctamente';
      } catch (e) {
        window?.$toast?.error?.(e?.message || 'No se pudo guardar');
      } finally {
        this.saving = false;
      }
    }
  },
  async mounted() {
    this.loading = true;
    try {
      const r = await SecurityModeService.getStatus({ force: false });
      this.enabled = !!r.enabled;
      this.hint = r.cached ? 'Cargado desde cache' : 'Cargado desde servidor';
      this.$store?.commit?.('setSecurityMode', this.enabled);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
.card
  text-align: left
  border-radius: 16px
  padding: 16px
  border: 1px solid rgba(15, 23, 42, .10)
  background: rgba(255,255,255,.96)
  box-shadow: 0 10px 30px rgba(15,23,42,.08)

.head
  margin-bottom: 12px

.title
  margin: 0
  font-weight: 900
  font-size: 1rem
  color: #0f172a

.desc
  margin: 6px 0 0
  font-size: .9rem
  color: #64748b
  font-weight: 600

.row
  display: flex
  align-items: center
  justify-content: space-between
  gap: 10px
  margin-top: 10px

.check
  display: inline-flex
  align-items: center
  gap: .55rem
  font-weight: 800
  color: #0f172a
  input
    transform: translateY(1px)

.pill
  padding: 6px 10px
  border-radius: 999px
  font-size: .75rem
  font-weight: 900
  border: 1px solid rgba(15,23,42,.12)
  &.on
    background: rgba(239, 68, 68, .12)
    color: #991b1b
    border-color: rgba(239, 68, 68, .22)
  &.off
    background: rgba(15,23,42,.06)
    color: #334155

.warnbox
  margin-top: 12px
  padding: 10px 12px
  border-radius: 12px
  background: rgba(245, 158, 11, .12)
  border: 1px solid rgba(245, 158, 11, .22)
  color: #92400e
  font-size: .9rem
  strong
    font-weight: 900

.actions
  margin-top: 12px
  display: flex
  gap: 10px
  flex-wrap: wrap
  align-items: center

.btn
  border-radius: 999px
  border: 1px solid rgba(15,23,42,.14)
  background: #ffffff
  color: #0f172a
  padding: 10px 14px
  font-weight: 900
  cursor: pointer
  transition: transform .08s ease, box-shadow .15s ease, background .15s ease
  &:hover
    background: rgba(15,23,42,.03)
    box-shadow: 0 8px 18px rgba(15,23,42,.08)
  &:active
    transform: translateY(1px)
  &:disabled
    opacity: .6
    cursor: not-allowed
    box-shadow: none

.btn.primary
  background: #2563eb
  color: #fff
  border-color: rgba(37,99,235,.55)
  &:hover
    background: #1d4ed8

.hint
  font-size: .85rem
  color: #64748b
  font-weight: 600
</style>